var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 48,
    viewBox: "0 0 250 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_6332_3384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.346 6.9488C107.951 6.51522 108.275 6.14533 108.699 4.26462C109.058 6.15986 109.369 6.5398 110.959 7.03037C109.353 7.46395 109.029 7.83384 108.605 9.71455C108.246 7.81931 107.936 7.43937 106.346 6.9488Z",
    fill: "url(#paint0_linear_6332_3384)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.699 1.57529C114.796 1.32083 115.017 1.10376 115.307 0C115.552 1.11228 115.764 1.33526 116.851 1.62317C115.754 1.87763 115.533 2.09471 115.243 3.19846C114.998 2.08618 114.786 1.8632 113.699 1.57529Z",
    fill: "url(#paint1_linear_6332_3384)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.002 5.2829C122.196 4.77398 122.638 4.33982 123.218 2.13231C123.708 4.35687 124.132 4.80283 126.305 5.37865C124.111 5.88757 123.669 6.32173 123.09 8.52924C122.599 6.30468 122.175 5.85872 120.002 5.2829Z",
    fill: "url(#paint2_linear_6332_3384)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.732 45.7764C169.262 45.7764 168.791 45.7466 168.32 45.6869C166.36 45.3685 164.663 44.6222 163.232 43.448C161.8 42.2738 160.732 40.811 160.026 39.0597C158.32 39.597 156.525 39.8657 154.643 39.8657C150.937 39.8657 147.927 38.8706 145.613 36.8804C143.319 34.8704 142.171 32.2334 142.171 28.9696C142.171 25.7057 143.348 23.0887 145.701 21.1184C148.054 19.1283 151.153 18.1332 154.996 18.1332C157.212 18.1332 159.369 18.362 161.467 18.8198C162.408 19.0188 163.173 19.2377 163.761 19.4765L163.467 25.2082H163.202C162.732 23.3374 161.8 21.9443 160.408 21.0289C159.035 20.0935 157.369 19.6258 155.408 19.6258C153.447 19.6258 151.829 20.5015 150.554 22.2528C149.28 24.0041 148.643 26.3127 148.643 29.1785C148.643 30.9896 148.917 32.5917 149.466 33.9848C150.015 35.3779 150.8 36.4625 151.819 37.2387C152.839 37.9949 153.966 38.3731 155.202 38.3731C156.457 38.3731 157.437 38.0845 158.143 37.5073C158.869 36.9103 159.232 36.1341 159.232 35.1789V31.1189C159.251 30.6811 159.124 30.3428 158.849 30.104C158.594 29.8651 158.222 29.7457 157.731 29.7457H157.29V29.4472H167.173V29.7457H166.703C166.232 29.7457 165.869 29.8651 165.614 30.104C165.359 30.3428 165.242 30.6811 165.261 31.1189V35.955C165.261 37.1093 165.487 38.2537 165.938 39.388C166.958 41.8956 168.585 43.5077 170.821 44.2241C171.468 44.4231 172.115 44.5226 172.762 44.5226C173.409 44.5226 174.046 44.453 174.674 44.3137L174.733 44.6122C172.968 45.3884 171.301 45.7764 169.732 45.7764Z",
    fill: "url(#paint3_linear_6332_3384)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.793 39.1492C169.303 39.1492 169.734 38.9701 170.087 38.6119C170.46 38.2337 170.656 37.786 170.676 37.2685V20.7303C170.656 20.0935 170.391 19.586 169.882 19.2079C169.568 18.969 169.205 18.8496 168.793 18.8496H168.411V18.5511H178.206C179.049 18.5511 179.794 18.4815 180.441 18.3421C181.108 18.2028 181.529 18.0934 181.706 18.0138V24.1633H181.412V23.9245C181.412 22.7503 181.088 21.8249 180.441 21.1483C179.794 20.4716 178.892 20.1134 177.735 20.0736H176.706V28.4024H180.794C181.735 28.3825 182.5 28.074 183.088 27.477C183.677 26.86 183.971 26.0739 183.971 25.1186V24.9992H184.265V33.2982H183.971V33.1489C183.971 32.2135 183.677 31.4473 183.088 30.8503C182.5 30.2333 181.745 29.9149 180.824 29.895H176.706V37.9253H182.088C183.52 37.9253 184.785 37.4476 185.883 36.4924C186.981 35.5371 187.755 34.2136 188.206 32.522H188.501L187.383 39.4477H168.411V39.1492H168.793Z",
    fill: "url(#paint4_linear_6332_3384)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.059 43.4778C220.863 44.2341 219.569 44.6122 218.177 44.6122C216.961 44.6122 215.696 44.244 214.382 43.5077C213.029 42.7713 211.706 41.7265 210.411 40.3732L197.499 26.8202V37.3282C197.499 37.8457 197.675 38.2835 198.028 38.6417C198.381 38.9801 198.803 39.1492 199.293 39.1492H199.852V39.4477H189.086V39.1492H189.645C190.135 39.1492 190.557 38.9801 190.91 38.6417C191.263 38.2835 191.439 37.8457 191.439 37.3282V20.4318C188.42 17.1679 185.772 15.536 183.498 15.536C182.929 15.536 182.38 15.6355 181.85 15.8345L181.703 15.5659C182.802 14.7698 183.988 14.3718 185.262 14.3718C186.106 14.3718 186.969 14.5409 187.851 14.8793C188.714 15.1977 189.469 15.5659 190.116 15.9838C191.332 16.7998 192.41 17.6953 193.351 18.6705L205.441 31.3578V20.6706C205.421 20.1532 205.235 19.7253 204.882 19.387C204.529 19.0287 204.107 18.8496 203.617 18.8496H203.058V18.5511H213.824V18.8496H213.294C212.804 18.8496 212.382 19.0287 212.029 19.387C211.676 19.7253 211.49 20.1432 211.47 20.6408V37.6865L212 38.2537C212 38.2537 212.225 38.5024 212.676 39C213.147 39.4975 213.461 39.8259 213.618 39.9851C213.794 40.1443 214.137 40.4528 214.647 40.9105C215.157 41.3881 215.569 41.7165 215.882 41.8956C216.196 42.0947 216.628 42.3434 217.177 42.6419C217.726 42.9604 218.226 43.1594 218.677 43.239C219.187 43.3584 219.726 43.4181 220.295 43.4181C220.863 43.4181 221.412 43.3385 221.942 43.1793L222.059 43.4778Z",
    fill: "url(#paint5_linear_6332_3384)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.82 39.1492H228.203V39.4477H217.643V39.1492H218.026C218.535 39.1492 218.967 38.9701 219.32 38.6119C219.692 38.2337 219.888 37.786 219.908 37.2685V20.0437L217.349 20.1333C215.702 20.193 214.819 20.8099 214.702 21.9841C214.702 22.0438 214.702 22.1035 214.702 22.1632C214.702 22.7205 214.888 23.1683 215.261 23.5066C215.633 23.8449 216.104 24.0141 216.673 24.0141C216.79 24.0141 216.908 24.0141 217.026 24.0141V24.1932C216.594 24.432 216.163 24.5514 215.731 24.5514C215.319 24.5514 214.898 24.4221 214.466 24.1633C213.643 23.6658 213.231 22.9295 213.231 21.9543C213.231 21.0388 213.584 20.2825 214.29 19.6855C214.996 19.0685 216.104 18.7302 217.614 18.6705C217.829 18.6506 218.516 18.6208 219.673 18.581C220.849 18.5412 221.859 18.5113 222.702 18.4914C225.134 18.372 226.967 18.1929 228.203 17.9541L228.262 18.2526C227.164 18.4317 226.467 18.9093 226.173 19.6855C226.036 20.0636 225.958 20.5413 225.938 21.1184V37.2685C225.938 37.786 226.124 38.2337 226.497 38.6119C226.869 38.9701 227.311 39.1492 227.82 39.1492Z",
    fill: "url(#paint6_linear_6332_3384)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.293 39.1492C230.802 39.1492 231.234 38.9701 231.587 38.6119C231.959 38.2337 232.155 37.786 232.175 37.2685V20.7303C232.155 20.0935 231.891 19.586 231.381 19.2079C231.067 18.969 230.704 18.8496 230.293 18.8496H229.91V18.5511H239.705C240.548 18.5511 241.293 18.4815 241.941 18.3421C242.607 18.2028 243.029 18.0934 243.205 18.0138V24.1633H242.911V23.9245C242.911 22.7503 242.588 21.8249 241.941 21.1483C241.293 20.4716 240.391 20.1134 239.234 20.0736H238.205V28.4024H242.294C243.235 28.3825 244 28.074 244.588 27.477C245.176 26.86 245.47 26.0739 245.47 25.1186V24.9992H245.764V33.2982H245.47V33.1489C245.47 32.2135 245.176 31.4473 244.588 30.8503C244 30.2333 243.245 29.9149 242.323 29.895H238.205V37.9253H243.588C245.019 37.9253 246.284 37.4476 247.382 36.4924C248.48 35.5371 249.255 34.2136 249.706 32.522H250L248.882 39.4477H229.91V39.1492H230.293Z",
    fill: "url(#paint7_linear_6332_3384)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.174 6.60757C117.288 6.31336 118.424 6.98475 118.712 8.10753C119 9.2303 118.331 10.3785 117.217 10.6727C116.103 10.9669 114.967 10.2955 114.679 9.17275C114.391 8.04997 115.061 6.90161 116.174 6.60757ZM124.767 40.12C128.522 39.1282 132.293 40.1244 134.85 42.4369C132.01 42.4282 128.884 42.8235 125.677 43.6704C122.47 44.5174 119.55 45.7179 117.075 47.1311C118.197 43.847 121.011 41.1118 124.767 40.12ZM105.473 35.7429C105.473 35.7429 101.741 38.1554 97.5929 37.1837C93.4452 36.212 92.2082 28.8532 96.6867 27.0977C101.165 25.3431 105.52 37.8135 117.86 38.6656C137.084 39.9933 139.881 8.0822 155.711 10.9871C152.47 8.4777 149.552 8.42689 146.868 9.48382C135.892 13.8059 131.924 28.8176 120.252 31.4166C109.528 33.8037 103.711 25.1115 97.4001 24.7735C91.0893 24.4349 87.4983 34.8564 92.5646 39.4135C97.6317 43.9711 105.474 35.7432 105.474 35.7432L105.473 35.7429ZM130.864 14.4314C114.693 13.0251 110.683 18.7403 110.721 21.5041C110.759 24.2671 114.367 25.5869 118.038 24.7691C121.709 23.9519 127.098 22.4473 126.595 20.3089C126.092 18.1705 114.373 20.365 114.373 20.365C122.462 15.6634 131.958 15.7594 131.892 18.915C131.854 20.7049 127.997 26.6676 119.503 28.5584C111.009 30.4492 105.976 26.2344 105.309 23.6338C104.642 21.0333 106.953 14.6122 116.545 12.4763C126.138 10.341 130.864 14.4314 130.864 14.4314Z",
    fill: "url(#paint8_linear_6332_3384)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.26554 21.3537C2.24617 20.2693 1.68463 19.7271 0.580907 19.7271C0.484089 19.7271 0.309817 19.7364 0.0580907 19.7551L0 19.5027C1.62654 19.3905 3.59194 19.1475 5.89621 18.7735C8.20047 18.3996 9.64306 18.1846 10.224 18.1285C10.8242 18.0724 11.3761 18.0444 11.8796 18.0444C13.4286 18.0444 14.6485 18.1846 15.5393 18.4651C16.4494 18.7268 17.2433 19.0727 17.921 19.5027C18.5987 19.9328 19.1409 20.5217 19.5475 21.2696C19.9929 22.0922 20.2156 22.971 20.2156 23.9058C20.2156 24.822 20.0897 25.6353 19.838 26.3458C19.5863 27.0563 19.228 27.6639 18.7633 28.1687C17.3691 29.7019 15.5877 30.4685 13.419 30.4685C12.6638 30.4685 11.9764 30.3563 11.3567 30.1319C10.2143 29.7206 9.47847 28.9914 9.14929 27.9444L9.43974 27.7761C9.71083 28.15 10.1562 28.337 10.7758 28.337C11.7246 28.337 12.567 27.7948 13.3028 26.7104C13.7481 26.0186 13.9708 25.1024 13.9708 23.9619C13.9708 22.3727 13.5545 21.1948 12.7219 20.4282C12.1022 19.8486 11.318 19.5588 10.3692 19.5588C10.1368 19.5588 9.89479 19.5775 9.64306 19.6149L8.21984 19.8112V36.1336C8.2392 36.6197 8.42316 37.0404 8.7717 37.3957C9.13961 37.7322 9.57529 37.9005 10.0787 37.9005H10.4563V38.1809H0.0290454V37.9005H0.406635C0.910088 37.9005 1.33609 37.7322 1.68463 37.3957C2.05254 37.0404 2.24617 36.6197 2.26554 36.1336V21.3537Z",
    fill: "url(#paint9_linear_6332_3384)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0923 12.2951C48.3634 12.2951 48.6345 12.3138 48.9056 12.3512V12.6316C47.1629 12.8373 45.8461 13.6319 44.9554 15.0155C44.0647 16.399 43.6193 18.2313 43.6193 20.5124V30.9733C43.5806 33.4413 42.7576 35.3297 41.1505 36.6384C39.5627 37.9285 37.2003 38.5736 34.0634 38.5736C30.9265 38.5736 28.4576 37.9005 26.6568 36.5543C24.856 35.2081 23.9556 33.4132 23.9556 31.1696C23.9556 31.1135 23.9556 31.0574 23.9556 31.0013V20.2039C23.9556 19.8112 23.8007 19.484 23.4909 19.2223C23.2004 18.9605 22.8422 18.8296 22.4162 18.8296H21.9515V18.5492H31.914V18.8296H31.4493C30.849 18.8296 30.4037 19.054 30.1132 19.5027C29.9971 19.7084 29.9293 19.9234 29.9099 20.1478V30.8891C29.9099 32.8336 30.4134 34.3668 31.4203 35.4886C32.4465 36.5917 33.802 37.1433 35.4866 37.1433C35.506 37.1433 35.5157 37.1433 35.5157 37.1433C35.535 37.1433 35.5544 37.1433 35.5738 37.1433C37.1809 37.1433 38.4977 36.6291 39.5239 35.6008C40.5696 34.5537 41.0924 33.1047 41.0924 31.2537V20.5124C41.0924 18.1939 41.7895 16.2027 43.1836 14.5387C43.842 13.7721 44.6069 13.2112 45.4782 12.856C46.369 12.482 47.2403 12.2951 48.0923 12.2951Z",
    fill: "url(#paint10_linear_6332_3384)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2464 41.9671C77.0652 42.6775 75.7872 43.0328 74.4124 43.0328C73.2118 43.0328 71.9629 42.6869 70.6655 41.9951C69.3295 41.3033 68.0224 40.3217 66.7444 39.0503L53.9935 26.3178V36.1897C53.9935 36.6758 54.1678 37.0872 54.5163 37.4237C54.8649 37.7416 55.2812 37.9005 55.7653 37.9005H56.3171V38.1809H45.6865V37.9005H46.2384C46.7225 37.9005 47.1388 37.7416 47.4873 37.4237C47.8359 37.0872 48.0102 36.6758 48.0102 36.1897V20.316C45.0282 17.2498 42.4141 15.7166 40.1679 15.7166C39.6064 15.7166 39.0642 15.8101 38.5414 15.9971L38.3961 15.7447C39.4805 14.9968 40.652 14.6228 41.9106 14.6228C42.7433 14.6228 43.5953 14.7818 44.4666 15.0996C45.3186 15.3988 46.0641 15.7447 46.7031 16.1373C47.9037 16.9039 48.9687 17.7452 49.8981 18.6614L61.8358 30.5806V20.5404C61.8164 20.0543 61.6324 19.6523 61.2839 19.3345C60.9353 18.9979 60.519 18.8296 60.0349 18.8296H59.4831V18.5492H70.1137V18.8296H69.5909C69.1068 18.8296 68.6905 18.9979 68.3419 19.3345C67.9934 19.6523 67.8094 20.0449 67.7901 20.5124V36.5263L68.3129 37.0591C68.3129 37.0591 68.5356 37.2928 68.9809 37.7603C69.4456 38.2277 69.7555 38.5362 69.9104 38.6858C70.0846 38.8353 70.4235 39.1251 70.9269 39.5552C71.4304 40.0039 71.837 40.3124 72.1469 40.4807C72.4567 40.6676 72.8827 40.9013 73.4249 41.1818C73.967 41.4809 74.4608 41.6679 74.9062 41.7427C75.4096 41.8549 75.9421 41.911 76.5037 41.911C77.0652 41.911 77.6074 41.8362 78.1302 41.6866L78.2464 41.9671Z",
    fill: "url(#paint11_linear_6332_3384)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5743 25.7288C69.3931 24.7192 68.8026 23.6347 68.8026 22.4755C68.8026 21.3911 69.2576 20.475 70.1677 19.7271C71.1359 18.9231 72.3945 18.5211 73.9436 18.5211H88.7858C89.386 18.5211 90.0347 18.4651 90.7318 18.3529C91.4289 18.2407 91.9227 18.1285 92.2131 18.0163V23.7937L91.9227 23.7656V23.5693C91.9227 22.0549 91.3418 20.9891 90.1799 20.3721C89.6184 20.0917 88.9503 19.9421 88.1758 19.9234H85.3294V36.1617C85.3487 36.6478 85.5327 37.0591 85.8812 37.3957C86.2491 37.7322 86.6848 37.9005 87.1883 37.9005H87.5659V38.1809H77.1386V37.9005H77.5162C78.0196 37.9005 78.4456 37.7322 78.7942 37.3957C79.1621 37.0591 79.3557 36.6571 79.3751 36.1897V19.9234H73.9436C72.8592 19.9234 71.9588 20.1758 71.2424 20.6806C70.4097 21.2602 69.9934 21.9894 69.9934 22.8682C69.9934 23.7282 70.2935 24.635 70.8938 25.5886L70.5743 25.7288Z",
    fill: "url(#paint12_linear_6332_3384)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_6332_3384",
    x: 0,
    y: 0,
    width: 250,
    height: 48.1312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_6332_3384"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6332_3384",
    x1: 170.082,
    y1: 0,
    x2: 170.082,
    y2: 47.1311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6332_3384",
    x1: 170.082,
    y1: 0,
    x2: 170.082,
    y2: 47.1311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6332_3384",
    x1: 170.082,
    y1: 0,
    x2: 170.082,
    y2: 47.1311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6332_3384",
    x1: 170.082,
    y1: 0,
    x2: 170.082,
    y2: 47.1311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6332_3384",
    x1: 170.082,
    y1: 0,
    x2: 170.082,
    y2: 47.1311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6332_3384",
    x1: 170.082,
    y1: 0,
    x2: 170.082,
    y2: 47.1311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6332_3384",
    x1: 170.082,
    y1: 0,
    x2: 170.082,
    y2: 47.1311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6332_3384",
    x1: 170.082,
    y1: 0,
    x2: 170.082,
    y2: 47.1311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6332_3384",
    x1: 170.082,
    y1: 0,
    x2: 170.082,
    y2: 47.1311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6332_3384",
    x1: 46.1066,
    y1: 12.2951,
    x2: 46.1066,
    y2: 43.0328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6332_3384",
    x1: 46.1066,
    y1: 12.2951,
    x2: 46.1066,
    y2: 43.0328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6332_3384",
    x1: 46.1066,
    y1: 12.2951,
    x2: 46.1066,
    y2: 43.0328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6332_3384",
    x1: 46.1066,
    y1: 12.2951,
    x2: 46.1066,
    y2: 43.0328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default ForwardRef;